import { render, staticRenderFns } from "./SacAverageTimeForTreatmentsByOperator.vue?vue&type=template&id=350de79e&"
import script from "./SacAverageTimeForTreatmentsByOperator.vue?vue&type=script&lang=js&"
export * from "./SacAverageTimeForTreatmentsByOperator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports